import { noop } from 'underscore';
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStoreFromProviderId } from '@bingads-webui-campaign-react/with-store-details';
import { withCustomValidation, withError } from '@bingads-webui-react/validation';
import { withUnvalidatedControlErrors, withControlErrorHandling } from '@bingads-webui-campaign-react/error-handling';
import { BusinessNameWithValidation } from '@bingads-webui-campaign-react/business-name';
import { RecommendationContext } from '@bingads-webui-campaign-react/perf-max-recommendation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';

const BusinessNameMaxLength = 25;

const StoreBackedBusinessName = (props) => {
  const {
    id,
    storeDetails,
    i18n,
    validationProps,
    updateValidation,
  } = props;

  const { data } = validationProps;
  const [recommendationContext] = useContext(RecommendationContext);
  const currentBusinessName = (data && data.BusinessName) || '';
  const storeName = storeDetails && storeDetails.name;
  const [prepopulated, setPrepopulated] = useState(false);

  const activity = useContext(ActivityContext);
  const businessNameRecommendationText = recommendationContext && recommendationContext.businessName && recommendationContext.businessName.Text;

  const [prevRecommendation, setPrevRecommendation] = useState();

  // handle prepopulate of store name on mount if there's no pre-existing business name
  useEffect(() => {
    if (!prepopulated) {
      setPrepopulated(true);
      if (storeName && !currentBusinessName) {
        updateValidation([], { BusinessName: storeName }, false /* shouldDirty */);

        if (activity) {
          activity.signal(`onBusinessNameChanged - name: ${storeName}`);
        }
      }
    }
  }, [prepopulated, storeName, currentBusinessName, updateValidation]);

  // triggered on recommendation change to populate recommendation if field is empty
  useEffect(() => {
    if (!prepopulated || prevRecommendation === businessNameRecommendationText) {
      // if we havn't yet prepopulated the business name, or if the recommendation hasn't changed, do nothing
      return;
    }

    // set the prev recommendation so we don't trigger this flow again
    setPrevRecommendation(businessNameRecommendationText);
    if (!currentBusinessName && businessNameRecommendationText) {
      updateValidation([], { BusinessName: businessNameRecommendationText }, false /* shouldDirty */);
    }
  }, [prepopulated, prevRecommendation, businessNameRecommendationText, currentBusinessName, updateValidation]);

  return (
    <BusinessNameWithValidation
      id={id}
      validationProps={{
        data: { BusinessName: currentBusinessName },
      }}
      maxLength={BusinessNameMaxLength}
      i18n={i18n}
      updateValidation={updateValidation}
    />);
};

StoreBackedBusinessName.propTypes = {
  id: PropTypes.string,
  storeDetails: PropTypes.shape({
    name: PropTypes.string,
  }),
  i18n: PropTypes.shape({}).isRequired,
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      BusinessName: PropTypes.string,
    }),
  }),
  updateValidation: PropTypes.func,
  recommendationContext: PropTypes.shape({
    businessName: PropTypes.string,
  }).isRequired,
};

StoreBackedBusinessName.defaultProps = {
  id: undefined,
  updateValidation: noop,
  storeDetails: undefined,
  validationProps: undefined,
};

export const ValidatedStoreBackedBusinessName
  = withControlErrorHandling(withUnvalidatedControlErrors(withError(withCustomValidation(withStoreFromProviderId(React.memo(StoreBackedBusinessName))))));
